import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {News, Response} from '../models/models';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  constructor(private httpClient: HttpClient) { }

  getNews(): Observable<Response<News[]>> {
    return this.httpClient.get<Response<News[]>>(environment.apiPath + 'News');
  }
}
